<div #template_node_tree_scroll_panel
     class="flex flex-1 overflow-auto justify-content-center max-h-modal-sidebar">
  <medsurf-design-content-template-node-tree class="w-full"></medsurf-design-content-template-node-tree>
</div>